import React from "react";
import { Divider, Typography } from "antd";
import styles from "./event.module.css";
import EventCalendar from "./components/EventCalender/eventCalender";

const Event = () => {
  return (
    <div className={styles.mainView}>
      <Typography className={styles.title}>Event</Typography>
      <Divider />
      <EventCalendar />
    </div>
  );
};

export default Event;
